import React from 'react';
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Tooltip,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import InputTitle from '../InputTitle';
import AutoComplete from '@material-ui/lab/Autocomplete';
import HelpIcon from '@material-ui/icons/Help';
import './ActualHours.scss';

/**
 * @typedef {{
 *  isActualHours: boolean,
 *  setIsActualHours: () => void,
 *  isSelectBreakRuleId?: boolean,
 *  breakRuleId?: number | null,
 *  setBreakRuleId?: () => void | null,
 *  breakRules?: RuleSet.IRuleSetBrief[] | null,
 *  helpIconTooltip?: string,
 *  isDisabled?: boolean,
 * }} ActualHoursProps
 * @param {ActualHoursProps} props 
 */
export default function ActualHours(props) {
    const { isActualHours, setIsActualHours, isSelectBreakRuleId = true, breakRuleId, setBreakRuleId = () => {}, breakRules = [], helpIconTooltip = "", isDisabled = false } = props;
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.scheduleRulesStep.actualHours' });
    const breakRuleOptions = [{id: null, name: t('defaultBreakRuleLabel')}, ...breakRules.map(x => ({ id: x.ruleSetId, name: x.name }))];

    /**
     * @param {boolean} isChecked 
     */
    const onChangeIsActualHours = (isChecked) => {
        // Reset sub-section value
        setBreakRuleId(null);
        setIsActualHours(isChecked);
    }

    return (
        <div>
            <FormControlLabel
                control={(
                    <Checkbox
                        checked={isActualHours}
                        onClick={({ target: { checked: isChecked } }) => onChangeIsActualHours(isChecked)}
                    />
                )}
                label={t('label')}
                disabled={isDisabled}
            />
            <Tooltip title={helpIconTooltip} arrow>
                <HelpIcon fontSize="small" />
            </Tooltip>
            {isSelectBreakRuleId && isActualHours && <div className='ac-break-rule-id-container'>
                <InputTitle>{t('breakRuleLabel')}</InputTitle>
                <AutoComplete
                    id="break-rule-select"
                    value={breakRuleOptions.find((x) => x.id === breakRuleId)}
                    options={breakRuleOptions}
                    onChange={(_event, optionSelected) => setBreakRuleId(optionSelected?.id)}
                    renderInput={(params) => (<TextField
                        {...params}
                        variant="outlined"
                        placeholder={t('breakRulePlaceholder')}
                    />)}
                    getOptionLabel={(option) => option.name}
                    includeInputInList
                    disableClearable
                    disabled={isDisabled}
                />
            </div>}
        </div>
    );
}